<template>
  <div
    class="file"
    :class="{ 'file--exceeded': exceeded }"
  >
    <div class="file__info">
      <div class="details">
        <div class="text">
          {{ data.name }}
        </div>
        <div class="size">
          {{ getSize }}
        </div>
      </div>
      <div class="loader" />
    </div>
    <div class="file__action">
      <a @click="removeFile(position)">
        <svg>
          <use
            xlink:href="#icon-close"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import emitter from 'tiny-emitter/instance'
/* eslint-disable */
  export default {
    name: 'nt-file',
    props: {
      data: {
        type: File
      },
      position: {
        type: Number
      },
      exceeded: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getSize() {
        const { size } = this.data;

        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (size === 0) return '0 Byte';

        const i = parseInt(Math.floor(Math.log(Math.abs(size)) / Math.log(1024)), 10);

        if (i === 0) {
          return `${size} ${sizes[i]})`;
        };
        return `${(size / (1024 ** i)).toFixed(2)} ${sizes[i]}`;
      }
    },
    methods: {
      removeFile(value) {
        emitter.emit('removeFile', value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .file {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: #F6F6F6;

    &__info {
      width: calc(100% - 30px);
      margin-right: 15px;

      & .details {
        display: flex;
        justify-content: space-between;

        & div {
          display: flex;
          align-items: center;
        }

        & .text {
          font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: calc(100% - 95px);
          display: block;
          overflow: hidden
        }

        & .size {
          color: #999999;
        }
      }

      & .loader {
        margin-top: 10px;
        height: 3px;
        border-radius: 10px;
        background-color: #23acd8;
      }
    }

    &__action {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      & a {
        display: flex;

        & svg {
          cursor: pointer;
          width: 16px;
          height: 16px;
          fill: #3e4444;
        }
      }
    }

    &--exceeded {
      & .loader {
        background-color: #E97462;
      }
    }
  }
</style>
